<mat-dialog-content>
  <h4 translate>{{ data.title }}</h4>
  <p>{{ data.subtitle | translate : data.contextParams }}</p>

  <div class="upload-box" (click)="fileInput.click()">
    <mat-icon fontIcon="bosch-ic-export"></mat-icon>
    <input
      type="file"
      #fileInput
      accept=".xlsx, .xls"
      hidden
      (change)="onFileSelected($event)"
    />
  </div>

  <button
    class="download-template sample-button sample-button--primary"
    (click)="downloadTemplate()"
    [disabled]="loading"
  >
    {{ "upload-template-modal.download-template" | translate }}
  </button>

  <div *ngIf="selectedFile" class="uploaded-file-name">
    <small>
      {{ "upload-template-modal.uploaded-file" | translate }}:
      <b>{{ selectedFile.name }}</b>
    </small>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    class="sample-button sample-button--primary"
    (click)="upload()"
    [disabled]="!selectedFile || loading"
  >
    {{ "upload-template-modal.import" | translate }}
  </button>
  <button mat-button (click)="cancel()" [disabled]="loading">
    {{ "input-cancel" | translate }}
  </button>
</mat-dialog-actions>
